export default "__VITE_ASSET__Cab_74c2__"